import {ProjectAccess} from "../../const/project";
import ProjectSession from "../../../model2/project/project-session";

export default class ACLProject {

    constructor(config?:any) {

    }

    static hasFullAccess(projectId:ID):boolean {

        const project   = gd.session.projects.get(projectId)!
        const access    = project?.access || undefined

        if (access) {
            return access >= gd.const.project.access.FULL
        }

        // template fix - not sure if good one but I think it's ok as undifined
        if (access === undefined && project.isTemplate && gd.company.role === gd.const.companyRole.MANAGER) {
            return true
        }

        return false
    }

    static hasStandardAccess(projectId:ID):boolean {

        const project   = gd.session.projects.get(projectId)!
        const access    = project?.access || undefined

        if (access) {
            return access >= gd.const.project.access.STANDARD
        }

        // template fix - not sure if good one but I think it's ok as undifined
        if (access === undefined && project.isTemplate && gd.company.role === gd.const.companyRole.MANAGER) {
            return true
        }

        return false
    }


    // static getAccess(projectId:ID):ProjectAccess|undefined {
    //
    //     const sessionProject = gd.session.projects.get(projectId) as Project
    //
    //     if (sessionProject) return sessionProject.access
    //
    //     if (!sessionProject) {
    //         console.error("#dkdjd2339038 no access possible")
    //         return undefined
    //     }
    //
    // }



    canModifyViews(projectId:ID):boolean {

        const projectUser = gd.session.projectUsers.findByProjectAndUser(projectId, gd.user.id)
        if (!projectUser) {
            console.warn("No project user found #94848203aa")
            return false
        }

        // verify with projectAccess settings
        switch (projectUser.access) {
            case ProjectAccess.FULL:
            case ProjectAccess.STANDARD:
            case ProjectAccess.LIMITED:
                return true

            case ProjectAccess.READ_ONLY:
            case ProjectAccess.CLIENT:
                return gd.company.settings.projectAccess.readonly.modifyViews
            default:
                console.error("unknonw option $033kkkk")
                return false
        }
    }

    static canAddUsers(projecId: ID) {
        return ACLProject.hasFullAccess(projecId)
    }


    canCreateTask(projectId?:ID) {

        if (!projectId) return false // can happen from views i.e. rootId in task list module

        // make sure this project can have tasks
        const project : ProjectSession | null = gd.session.projects.get(projectId)
        if (!project) return false

        return project.canCreateTask()

    }

    canCreateProject(parentProjectId:ID) {

    }



}